<div
  class="item bg-gray-50 rounded-xl ca-shadow flex items-center mb-5"
  [class.pointer]="openable"
  (click)="openFile()"
  >
  <div class="icon">
    <ca-file-icon [mimeType]="type" item-start></ca-file-icon>
  </div>

  <div class="meta">
    <div class="supertitle">{{ name }}</div>
    <div class="file-body">
      {{ size | filesize }}
      @if (size) {
        <br />
      }
      {{ created | caDate : "timestamp" }}
    </div>

    @if (showVisibility) {
      <span class="note" *hasRole="DASHBOARD_ROLES">
        @if (roles) {
          <span>
            {{
            "sharedWith"
            | translate
            : {
            roles: roles | translateroles : "plural" | formattedlist
          }
          }}
        </span>
      } @else {
        {{
        "sharedWith"
        | translate
        : {
        roles:
        NULL_ROLES_VISIBILITY
        | translateroles : "plural"
        | formattedlist
      }
      }}
    }
  </span>
}
</div>
@if (showActions) {
  <button
    data-test-id="moreMenuButton"
    *hasRole="DASHBOARD_ROLES"
    mat-icon-button
    [matMenuTriggerFor]="moreMenu"
    (click)="$event.stopPropagation()"
    >
    <mat-icon>more_vert</mat-icon>
  </button>
}
</div>

<mat-menu #moreMenu="matMenu">
  @if (viewHistory !== undefined) {
    <button
      data-test-id="viewHistoryButton"
      [disabled]="loading"
      (click)="viewHistory.emit(file)"
      mat-menu-item
      >
      <mat-icon item-start>history_outlined</mat-icon>
      View History
    </button>
  }
  <button [disabled]="loading" (click)="updateRoles()" mat-menu-item>
    <mat-icon item-start>visibility</mat-icon>
    {{ "whoShouldSeeThis" | translate }}
  </button>
  <button [disabled]="loading" (click)="remove.emit()" mat-menu-item>
    <mat-icon item-start>close</mat-icon>
    Remove
  </button>
</mat-menu>
